import * as React from 'react';

import { Button, Modal } from 'react-bootstrap';

import { ApplicationHelpType } from '../../utilities/Constants';
import classNames from 'classnames';

export interface IHelpProps {
    customIcon?: React.ReactNode;
    additionalStyleClassNames?: string;
    iconColorVariant?: 'white' | 'gray' | 'red';
    helpText: string;
    size?: 'sm' | 'lg';
    title: string;
    subTitle?: string;
    type: ApplicationHelpType;
}

interface IHelpState {
    showDialog: boolean;
}

export class Help extends React.Component<IHelpProps, IHelpState> {
    constructor(props: IHelpProps) {
        super(props);

        this.state = { showDialog: false };
    }

    getClassName() {
        let iconClass = '';
        switch (this.props.type) {
            case ApplicationHelpType.Info:
                iconClass = 'fa-info-circle';
                break;
            case ApplicationHelpType.Check:
                iconClass = 'fa-check-circle';
                break;
            case ApplicationHelpType.Error:
                iconClass = 'fa-regular fa-square-exclamation';
                break;
            default:
                iconClass = '';
        }

        const colorVariant = this.props.iconColorVariant
            ? `color-${this.props.iconColorVariant}`
            : 'color-gray';

        const sizeClass = this.props.size === 'sm' ? 'fa-sm' : 'fa-lg';

        return classNames('fal', iconClass, sizeClass, colorVariant);
    }

    render() {
        return (
            <span>
                <button
                    className={'mx-2 btn-no-bg ' + (this.props.additionalStyleClassNames || '')}
                    onClick={(event: React.FormEvent<HTMLButtonElement>) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.setState({ showDialog: true });
                    }}
                >
                    {this.props.customIcon ?? <i className={this.getClassName()} />}
                </button>
                {this.state.showDialog && (
                    <Modal
                        centered
                        show={this.state.showDialog}
                        onHide={() => this.setState({ showDialog: false })}
                        backdropClassName="transparent-background"
                    >
                        <Modal.Header>
                            <Modal.Title>
                                <span>{this.props.title}</span>
                                <span className="padding-left-lg font-size-xs">
                                    {this.props.subTitle ?? ''}
                                </span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="pb-2">
                            {this.props.helpText
                                .replace(/\\n/gi, '\n')
                                .split('\n')
                                .map((item, key) => {
                                    return (
                                        <span key={key}>
                                            {item}
                                            <br />
                                        </span>
                                    );
                                })}
                        </Modal.Body>
                        <Modal.Footer className="border-top-0 pt-0">
                            <Button
                                variant="dark"
                                onClick={(event: React.FormEvent<HTMLButtonElement>) => {
                                    event.preventDefault();
                                    this.setState({ showDialog: false });
                                }}
                            >
                                OK
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </span>
        );
    }
}
